// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39P0a","delete":"styles_delete__3xUzy","update":"styles_update__3DhRG","add":"styles_add__3FMKl"};